import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=6f4412b8&scoped=true&"
import script from "./MyHistory.vue?vue&type=script&lang=js&"
export * from "./MyHistory.vue?vue&type=script&lang=js&"
import style0 from "./MyHistory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MyHistory.vue?vue&type=style&index=1&id=6f4412b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4412b8",
  null
  
)

export default component.exports